import { useDispatch } from "react-redux";
import { setAddedShapeStatus } from "redux/MapSlice";
import { useEditableArea } from "./MapDetails";
import { setIsDrawingStatus } from "redux/CourseMapSlice";

export const useMapControls = (mapRef, editControlRef, isGoogleView) => {
  const editableArea = useEditableArea();

  const dispatch = useDispatch();
  const zoomIn = () => {
    if ((!isGoogleView && mapRef.current.getZoom() < 18) || isGoogleView) {
      mapRef.current.setZoom(mapRef.current.getZoom() + 1); // maxZoom can not be fixed dynamically ~ need to check
    }
    // else if (isGoogleView){
    //   mapRef.current.setZoom(mapRef.current.getZoom() + 1); //**original */

    // }
  };

  const zoomOut = () => {
    mapRef.current.setZoom(mapRef.current.getZoom() - 1);
  };
  const enableDrawMode = (mode) => {
    if (!editControlRef.current) {
      return;
    }
    setTimeout(() => {
      const drawControl = editControlRef.current;
      drawControl?._toolbars?.draw?._modes?.[mode]?.handler?.enable();
    }, 100);
  };

  const drawPolyLine = () => {
    enableDrawMode("polyline");
  };
  const drawPolygon = () => {
    enableDrawMode("polygon");
  };

  const drawPoint = () => {
    enableDrawMode("marker");
  };

  const drawRectangle = () => {
    enableDrawMode("rectangle");
  };
  const disableDraw = () => {
    //TODO
    if (!editControlRef.current) {
      return;
    }
    let drawControl = editControlRef.current;
    if (editableArea) {
      drawControl._toolbars.edit._modes.edit.handler.disable();
    } else {
      drawControl._toolbars.draw._modes.circle.handler.disable();
      drawControl._toolbars.draw._modes.marker.handler.disable();
      drawControl._toolbars.draw._modes.polygon.handler.disable();
      drawControl._toolbars.draw._modes.polyline.handler.disable();
      drawControl._toolbars.draw._modes.rectangle.handler.disable();
    }

    dispatch(setAddedShapeStatus("idle"));
    dispatch(setIsDrawingStatus(false)) // for course map


    // drawControl._toolbars.draw._modes.edit.handler.disable();

    // logger("drawControl", drawControl);
    // drawControl._toolbars.draw._modes.polygon.handler.enable();
  };

  const flyTo = (coords, Zoom,duration=2) => {
    const map = mapRef.current; // Access the map instance using the ref
    if (map) {
      map.flyTo(coords, Zoom, {
        duration: duration, // Animation duration in seconds
      });
    }
  };
  const setMapView = (
    coords,
    Zoom
  ) => {
    const map = mapRef.current; // Access the map instance using the ref
    if (map) {
      map.setView(coords, Zoom); // to set view-- no animation
    }
  };

  return {
    zoomOut: zoomOut,
    zoomIn: zoomIn,
    drawPolyLine: drawPolyLine,
    drawPolygon: drawPolygon,
    drawPoint: drawPoint,
    disableDraw: disableDraw,
    flyTo: flyTo,
    setMapView: setMapView,
    drawRectangle: drawRectangle,
  };
  //   return (
  //     <div>useMapControls</div>
  //   )
};
